export default {
  type: {
    DGAbstract: 'Medical Abstract',
    DGDispatch: 'Conference Dispatch'
  }
}
